import styled, { css } from 'styled-components';
import { media } from 'utils/rwd';

export const Switcher = styled.div`
  position: relative;
  display: flex;
  width: max-content;
  min-height: 48px;
  padding: 4px;
  border: 1px solid rgba(18, 14, 2, 0.08);
  border-radius: 999px;
  align-items: center;
  gap: 2px;
  background: #ffffff;
  box-shadow:
    0 12px 30px rgba(18, 14, 2, 0.12),
    0 2px 8px rgba(18, 14, 2, 0.06);

  ${({ $floating }) =>
    $floating &&
    css`
      position: fixed;
      top: 12px;
      left: 50%;
      z-index: 10000;
      transform: translateX(-50%);
    `}

  ${media.md`
    display: none;
  `}
`;

export const Switch = styled.button`
  display: inline-flex;
  height: 38px;
  padding: 0 18px;
  border: 0;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  background: ${({ $selected }) => ($selected ? 'var(--bs-primary-5)' : 'transparent')};
  color: ${({ $selected }) => ($selected ? 'var(--bs-primary)' : '#495057')};
  font-family: 'Cerebri Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;

  &:hover {
    color: #120e02;
    background: #f1f3f5;
  }

  &:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 3px rgba(190, 22, 34, 0.22);
  }
`;
